<template>
  <el-table
      :data="registries"
      style="width: 100%"
      row-key="id"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
    <el-table-column
        width="90"
        prop="id"
        label="ID" />

    <el-table-column
        with="100"
        prop="device_id"
        label="Device ID" />

    <el-table-column
        width="100"
        prop="state"
        label="State" />

    <el-table-column
        width="200"
        :show-overflow-tooltip="true"
        prop="agent"
        label="Agent" />

    <el-table-column
        style="font-size: small"
        prop="created_at"
        label="Date" />

    <el-table-column
        width="300"
        :show-overflow-tooltip="true"
        prop="checks"
        label="Checks" />
  </el-table>
</template>

<script>
import { get, concat, merge } from "lodash";

export default {
  name: "AccessoryRmaRequests",
  props: {
    registries: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    timeZone() {
      return this.$store.getters["ui/currentTimezone"];
    },
    rmas() {
      return this.registries.map((record) => {
        record.created_at = this.$moment
          .tz(self.created_at, this.timeZone)
          .format("MM/DD/YYYY - hh:mm A Z (z)");
        return record;
      });
    },
  },
  methods: {},
};
</script>

<style scoped></style>
